export const isDevelopmentMode = (!process.env.NODE_ENV || process.env.NODE_ENV === 'development');

export const EXPIRATION_WINDOW_IN_SECONDS = 1200;

export const BASE_URL =  isDevelopmentMode ? '.localhost:9001/api/v1' : '.protrack.co.tz/api/v1';

export const allowedSubdomains = ['demo', 'fivestar'];

export const drawerWidth = 240;